import React, { Component} from 'react';
import { getFileName } from '../../../helpers/FileCaching';
import classes from './Menu.module.scss';
import globalJson from '../../../data/global.json';
import IsNotDomestic from '../../../helpers/IsNotDomestic';

class Menu extends Component {

    constructor(props) {
        super(props);
        this.globalImages = this.props.globalImages;
    }

    onClick(event){
		window.gtag('event', "client logo clicked", {
		    'event_category': globalJson.tracking.ga_category,
			'event_label': "client logo clicked "+ event.currentTarget.href,
			'value':10
          });
    }
    
    render() {
        return (
            <div id={"main_menu"} className={classes['main-menu']}>
                <div className={classes['main-menu__wrap']}>
                    <div className={classes['main-menu-exposed']}>
                        <div className={classes['main-menu-exposed__container']}>
                            <div className={classes['main-menu-exposed__left-container']}>
                                <div className={`${classes['main-menu-exposed__logo-container']} ${classes['main-menu__bbc-logo']}`}>
                                    <a className={classes['main-menu-exposed__bbc-logo']} href={globalJson.bbcLogo.link} target="blank">
                                        <img alt="{{@root.bbc.alt}}" src={getFileName(this.globalImages, 'bbc-logo.png')} />
                                    </a>
                                </div>
                            </div>
                            <div className={classes['main-menu-exposed__right-container']}>
                                
                                {/* <IsNotDomestic>
                                    <div className={`${classes['sponsor-link']} ${classes['style-light']}`}>
                                        <p className={`${classes['sponsor-link__title']}
                                                ${classes['style-light']}`}
                                            dangerouslySetInnerHTML={{ __html: globalJson.clientLogo.text }}>
                                        </p>
                                        <a onClick={this.onClick} className={`${classes['sponsor-link__logo-link']}`} href={globalJson.clientLogo.link} target="_blank">
                                            <div  className={`${classes['main-menu-exposed__logo-container']}`}>
                                                <div className={`${classes['sponsor-link__logo']} ${classes['sponsor-link__client_logo']}`}>
                                                    <img alt="client logo" src={getFileName(this.globalImages, 'REI_logo.png')} />
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </IsNotDomestic> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Menu;